import { useRef, useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setCredentials } from "./authSlice";
import { useLoginMutation } from "./authApiSlice";
import usePersist from "../../hooks/usePersist";
import useTitle from "../../hooks/useTitle";
// import PulseLoader from 'react-spinners/PulseLoader'
import { Callout } from "@tremor/react";
import LandingHeader from "../../components/LandingHeader";
import LandingFooter from "../../components/LandingFooter";

const Email = () => {
  const userRef = useRef();
  const errRef = useRef();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [errMsg, setErrMsg] = useState("");
  const [persist, setPersist] = usePersist();

  const [showModalResetEmail, setShowModalResetEmail] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [login, { isLoading }] = useLoginMutation();

  useEffect(() => {
    userRef.current.focus();
  }, []);

  useEffect(() => {
    setErrMsg("");
  }, [username, password]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const { accessToken } = await login({ username, password }).unwrap();
      dispatch(setCredentials({ accessToken }));
      setUsername("");
      setPassword("");
      navigate("/dash");
    } catch (err) {
      if (!err.status) {
        setErrMsg("Nema odgovora od servera!");
        errRef.current.style = "display:block";
      } else if (err.status === 400) {
        setErrMsg("Morate uneti Username ili Password");
      } else if (err.status === 401) {
        errRef.current.style = "display:block";
        console.log(errRef);
        setErrMsg("Korisnik ne postoji");
        errRef.current.style = "display:block";
      } else {
        setErrMsg(err.data?.message);
      }
      errRef.current.focus();
    }
  };

  const handleUserInput = (e) => setUsername(e.target.value);
  const handlePwdInput = (e) => setPassword(e.target.value);
  const handleToggle = () => setPersist((prev) => !prev);

  const errClass = errMsg ? "errmsg" : "offscreen";

  // if (isLoading) return <PulseLoader color={"#FFF"} />

  const tailwindLogin_ = (
    <div className="flex items-center justify-center min-h-screen">
      <div className="md:w-full">
        <div className="sm:mx-auto sm:w-full sm:max-w-md"></div>

        <div className="mt-2 sm:mx-auto sm:w-full sm:max-w-[480px] border-4 border-[#66BB6A] rounded-3xl p-4 bg-white">
          <div
            className="bg-white px-3 py-6 shadow rounded-3xl sm:px-6 border-4 border-[#DCC72A]"
            // onClick={handleModalClick}
          >
            <Callout
              ref={errRef}
              className={errClass}
              color="red"
              style={{ display: "none" }}
            >
              {errMsg}
            </Callout>
            <form className="space-y-6" onSubmit={handleSubmit}>
              <h2 className="mt-1 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900">
                Reset lozinke
              </h2>
              <div>
                <label
                  htmlFor="text"
                  className="block text-sm font-medium leading-6 text-gray-900"
                >
                  Lozinka
                </label>
                <div className="mt-2">
                  <input
                    type="text"
                    id="username"
                    ref={userRef}
                    value={username}
                    onChange={handleUserInput}
                    autoComplete="off"
                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-green-600 sm:text-sm sm:leading-6"
                    required
                  />
                </div>
              </div>

              <div>
                <label
                  htmlFor="password"
                  className="block text-sm font-medium leading-6 text-gray-900"
                >
                  Potvrdite lozinku
                </label>
                <div className="mt-2">
                  <input
                    type="password"
                    id="password"
                    onChange={handlePwdInput}
                    value={password}
                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-green-600 sm:text-sm sm:leading-6"
                    required
                  />
                </div>
              </div>

              <div>
                <button
                  type="submit"
                  className="flex w-full justify-center rounded bg-green-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-green-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-600"
                >
                  Pošalji
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );

  //Stari izgled ali
  const tailwindLogin = (
    <div className="flex min-h-full flex-1 flex-col justify-center py-10 sm:px-6 lg:px-8 h-screen">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <h2 className="mt-6 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900">
          Reset lozinke
        </h2>
        {/* Ovde postavi tremor callout crveni */}
        <Callout
          ref={errRef}
          className={errClass}
          color="red"
          style={{ display: "none" }}
        >
          {errMsg}
        </Callout>
        {/* <p ref={errRef} className={errClass} aria-live="assertive">{errMsg}</p> */}
      </div>

      <div className="mt-2 sm:mx-auto sm:w-full sm:max-w-[480px] border border-black-500">
        <div className="bg-white px-3 py-6 shadow sm:rounded sm:px-6">
          <form className="space-y-6" onSubmit={handleSubmit}>
            <div>
              <label
                htmlFor="text"
                className="block text-sm font-medium leading-6 text-gray-900"
              >
                Lozinka
              </label>
              <div className="mt-2">
                <input
                  type="text"
                  id="username"
                  ref={userRef}
                  value={username}
                  onChange={handleUserInput}
                  autoComplete="off"
                  className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-green-600 sm:text-sm sm:leading-6"
                  required
                />
              </div>
            </div>

            <div>
              <label
                htmlFor="password"
                className="block text-sm font-medium leading-6 text-gray-900"
              >
                Potvrdite lozinku
              </label>
              <div className="mt-2">
                <input
                  type="password"
                  id="password"
                  onChange={handlePwdInput}
                  value={password}
                  className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-green-600 sm:text-sm sm:leading-6"
                  required
                />
              </div>
            </div>

            <div>
              <button
                type="submit"
                className="flex w-full justify-center rounded bg-green-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-green-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-600"
              >
                Pošalji
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );

  return (
    <>
      {/* <LandingHeader /> */}
      {tailwindLogin_}
      {/* <LandingFooter /> */}
    </>
  );
};
export default Email;
